import { forwardRef } from "react";

import { PhoneMask } from "utils/masks";

/**
 * MUI v5 compatible wrapper around utils/masks PhoneMask.
 * MUI v5 passes a `ref` (not `inputRef`) to `inputComponent` and expects it to
 * point to the DOM input, so the ref is forwarded through react-text-mask's render prop.
 */
const PhoneMaskInput = forwardRef((props, ref) => (
	<PhoneMask
		{...props}
		inputRef={() => {}}
		render={(textMaskRef, inputProps) => (
			<input
				{...inputProps}
				ref={node => {
					textMaskRef(node);
					if (typeof ref === "function") {
						ref(node);
					} else if (ref) {
						ref.current = node;
					}
				}}
			/>
		)}
	/>
));

export default PhoneMaskInput;
